const _state = {
  count:0,
  topnavnum:"1"
}

const mutations = {
  increment (state) {
    state.count ++
  }
}
const getters = {
  getTopnavnum(state) {
    return state.topnavnum
  }
}
// const actions = {
//   increment(context, topnavnum) {
//     context.commit('increment', topnavnum)
//   }
// }

export default {
  state: _state,
  getters,
  mutations,
  // actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js